import { useLocation, useNavigate } from "react-router-dom";
import nameConversion from "./nameConversion";

const useDynamicRouting = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleDynamicRouting = (type, id, title) => {
    let flow = nameConversion(
      type
        ?.split("_")
        ?.slice(0, -1)
        ?.join(",")
        ?.replaceAll(",", "_")
        ?.toLowerCase(),
    );
    let flowType = type?.split("_")?.slice(-1);
    let parsedId = id;

    if (typeof id === "string") {
      try {
        const parsed = JSON.parse(id);

        if (Array.isArray(parsed)) {
          parsedId = parsed;
        }
      } catch {}
    }
    let route;
    if (type === "beneficiary_schedule_transaction") {
      route = `/${flow}_transaction_dashboard/schedule_view_all/schedule_detail_page/${parsedId}`;
    } else if (type === "bulk_transaction") {
      route = `/beneficiary_transaction_dashboard/bulk_transaction_view_all/bulk_transaction_detail_page/${parsedId}`;
    } else {
      if (Array.isArray(parsedId)) {
        route = `/${flow}_${flowType}_dashboard/${flow}_${flowType}_view_all`;
      } else {
        route = `/${flow}_${flowType}_dashboard/${flow}_${flowType}_view_all/${flow}_${flowType}_detail_page/${parsedId}`;
      }
    }

    // Checks if the resolved route ends with 'view_all' (matches bulk/list routes)
    const isViewAllRoute = route.endsWith("view_all");

    navigate(route, {
      state: {
        isViewAll:
          location.pathname ===
          "/home/notification_dashboard/view_notifications"
            ? true
            : false,
        approvalStatus: title?.toLowerCase()?.includes("approved")
          ? "approved"
          : "rejected",
        notificationRoute: route,
        fromNotification: true,

        // Only attach txn_id if route ends with "view_all"
        ...(isViewAllRoute && { txn_id: parsedId }),
      },
    });
  };

  return { handleDynamicRouting };
};

export default useDynamicRouting;
